<script lang="ts">
  import { applyAction, enhance } from '$app/forms';
  import { refreshAll } from '$app/navigation';
  import FloatingLabel from '#lib/components/FloatingLabel.svelte';
  import Modal from '#lib/components/Modal.svelte';

  let resultData: { datacenter?: { error: Record<string, string | string[]> } } = $state({});
  let errors = $derived(resultData.datacenter?.error);

  let { open = $bindable(false) } = $props();
</script>

<Modal header="Add a datacenter" bind:open>
  <form
    method="post"
    action="?/datacenter"
    use:enhance={({ formElement }) => {
      return async ({ result }) => {
        await applyAction(result);

        if (result.type === 'success') {
          formElement.reset();
          await refreshAll();
          open = false;
        } else if (result.type === 'failure') {
          resultData = result.data ?? {};
        }
      };
    }}
  >
    <section class="grid grid-cols-2 gap-x-8 gap-y-4">
      <!-- TODO: show errors -->
      <FloatingLabel title="Name" error={errors?.name}>
        {#snippet input(placeholder)}
          <input name="name" class="input" required {placeholder} />
        {/snippet}
      </FloatingLabel>
      <FloatingLabel title="Location">
        {#snippet input(placeholder)}
          <input name="location" class="input" {placeholder} />
        {/snippet}
      </FloatingLabel>
    </section>
    <div class="modal-action">
      <button class="btn btn-secondary btn-ghost" type="reset" onclick={() => (open = false)}>
        Cancel
      </button>
      <button type="submit" class="btn btn-primary">Submit</button>
    </div>
  </form>
</Modal>
